<template lang="pug">
  .component-reveal-void
    ModalReveal
      button.button.danger(slot="trigger") Usage details
      .header(slot="header")
        h2  PR{{item.id}}&nbsp;
        Cards(:data="packetData")
      base-list(:component="component", :data-loader="dataLoader", componentType="usages")
</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import ActionButton from '../../ActionButton'
import Transaction from '../../../../backoffice/Transaction'
import BaseList from '../../../../../pages/backoffice/BaseList'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import Cards from '../../../Cards'

export default {
  name: 'PacketRecordUsageReveal',
  components: {Cards, BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      component: require('../../../../backoffice/PacketRecord'),
      items: [],
      loaded: false
    }
  },
  created() {
  },

  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.packetRecords.list.usages(this.item.id, page, resultsPerPage, (data) => {
        this.items = data.items
        this.loaded = true
        callback(data)
      }, (e) => alert(e))
    }
  },
  computed: {
    packetData() {
      return [
        {
          title: 'Minutes',
          value: this.item.minutes
        },
        {
          title: 'Remaining minutes',
          value: this.item.remaining_minutes
        },
        {
          title: 'Distance',
          value: this.item.distance
        },
        {
          title: 'Remaining distance',
          value: this.item.remaining_distance
        },
      ]
    }
  },

  props: ['buttons', 'item'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// PacketRecordUsageReveal.vue?61e987fc